import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import { useHistory, useParams } from "react-router-dom";
import Switch from "@material-ui/core/Switch";
//import { add_instructor,upload_image } from "../../DAL/instructor/instructor";
import { useSnackbar } from "notistack";
import SettingsIcon from "@material-ui/icons/Settings";
import {
  InputLabel,
  Select,
  FormControl,
  FormControlLabel
} from "@material-ui/core";
import { edit_token, token_detail } from "../../DAL/token/token";
import { countries_list } from "../../DAL/country/country";

const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    backgroundColor: "#000",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    marginTop: "3%",
    color: "white",

    fontSize: "15px",
  },
  txt: {
    color: "black",
    marginTop: "4%",
    marginBottom:20
  },
  alert: {
    width: "100%",
    marginBottom: 20,
  },
  avtr: {
    width: 80,
    height: 80,
    cursor: "pointer",
    backgroundColor: "#37CD77",
    color: "white",
  },
  blog_img: {
    marginTop: 10,
    width: 550,
    height: 300,
  },
  img: {
    width: "100%",
    height: "100%",
  },
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function Edit_Token(props) {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams()
  const { enqueueSnackbar } = useSnackbar();
  const [tokens, setTokens] = useState("");
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("");
  const [tag_name, setTag_Name] = useState("");
  const [active, setActive] = useState(true);
  const [countries, setCountries] = useState([]);
  const [errorflag, setflag] = useState("");
  const [iswaiting, setiswaiting] = useState(false);
  
  

  const handleback = () => {
    history.goBack();
  };
  const handlesubmit = async (event) => {
    event.preventDefault();
    setiswaiting(true);
    const data = {
      tokens,
      // description,
      price,
      currency,
      tag_name,
      active
    };
    const response = await edit_token(id, data);
    console.log(response, "response");
    if (response.code !== 200) {
      enqueueSnackbar(response.message, { variant: "error" });
      setiswaiting(false);
    } else {
      enqueueSnackbar("Token Updated Successfully", { variant: "success" });
      props.history.push("/tokens");
    }
  
  };

  const get_countries = async () => {
    setiswaiting(true)
    const country = await countries_list();
    if(country.code === 200){
      setCountries(country.countries)
      setiswaiting(false)
    }
    
  }

  const get_token_detail = async () => {
    setiswaiting(true)
    const token = await token_detail(id);
    if(token.code === 200){
      setTokens(token.token.tokens)
      setCurrency(token.token.currency._id)
      setPrice(token.token.price)
      setTag_Name(token.token.tag_name)
      // setActive(token.token.active)
      setiswaiting(false)
    }
    
  }

  useEffect(()=>{
    get_token_detail();
    get_countries();
  },[])

  if(iswaiting){
    return <CircularProgress style={{paddingTop:"25%", paddingLeft: "50%"}} />
  }
  
  return (
    <>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <div className={classes.paper}>
          <ArrowBackIcon
            style={{
              cursor: "pointer",
              marginLeft: "-550px",
            }}
            onClick={handleback}
          /> 
          <Avatar className={classes.avatar}>
          <SettingsIcon />
        </Avatar>
          <Typography
            className={classes.txt}
            component="h1"
            variant="h5"
          >Edit Token</Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <Grid container spacing={3} >
          
            <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
              <TextField
              required
          id="outlined-multiline-static"
          label="Tokens"
          className={classes.textField}
          margin="normal"
          variant="outlined"
          fullWidth
          value={tokens}
          onChange={(e)=> setTokens(e.target.value)}
          name="tokens"

        />
         </Grid>

         <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
              <TextField
              required
          id="outlined-multiline-static"
          label="Price"
          className={classes.textField}
          margin="normal"
          variant="outlined"
          fullWidth
          value={price}
          onChange={(e)=> setPrice(e.target.value)}
          name="price"

        />
         </Grid>

         <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
         <FormControl variant="outlined" className={classes.formControl} fullWidth>
        <InputLabel htmlFor="outlined-age-native-simple">Currency</InputLabel>
        <Select
          native
          value={currency}
          onChange={(e)=> setCurrency(e.target.value)}
          label="Currency"
          inputProps={{
            name: 'currency',
            id: 'outlined-age-native-simple',
          }}
        >
          <option aria-label="None" value="" />
          {countries.map((x)=>(
            <>
            <option value={x._id}>{x.currency}</option>
          </>
          ))}
        </Select>
      </FormControl>
          </Grid>

         <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
              <TextField
              // required
          id="outlined-multiline-static"
          label="Offer Name"
          className={classes.textField}
          margin="normal"
          variant="outlined"
          fullWidth
          value={tag_name}
          onChange={(e)=> setTag_Name(e.target.value)}
          name="tag_name"

        />
         </Grid>

         <Grid item xs={12} style={{paddingTop:0,paddingBottom:0}}>
         <FormControlLabel
        control={
          <Switch
            checked={active}
            onChange={(event)=> setActive(event.target.checked)}
            name="active"
            color="primary"
          />
        }
        label="Status"
      />
         </Grid> 
             

              <Grid item xs={12}
          style={{paddingTop:0,paddingBottom:0}}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Edit Token
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
